
import {UserClimbingEvent} from "../../../../models/UserClimbingEvent";
import {ClimbingEvent} from "../../../../models/ClimbingEvent";
import {FC} from "react";
import {EditUserEventDetailsComponent} from "../../../event/userEventData/components/EditUserEventDetailsComponent";
import {Box} from "@mui/system";
import {Typography} from "@mui/material";
import {EditUserRoutes} from "./EditUserRoutes";

type Props = {
  userEvent: UserClimbingEvent,
  event: ClimbingEvent,
  updateUserData: (userEvent: UserClimbingEvent) => void
}
export const EditUserResults: FC<Props> = ({userEvent, event, updateUserData}) => {

  return (
    <Box display={'flex'} flexDirection={"column"} gap={2}>
      <Typography variant={"h6"}>Edycja danych</Typography>
      <EditUserEventDetailsComponent userEvent={userEvent} event={event} handleUpdate={updateUserData}/>
      <Typography variant={"h6"}>Edycja wyników</Typography>
      <EditUserRoutes userEvent={userEvent} event={event} updateUserData={updateUserData}/>
    </Box>
  )
}